// quotationStatus.js — SINGLE SOURCE OF TRUTH for quotation lifecycle status + revision "heads".
// Used by the Quotations page lists AND the Dashboard KPI counts so a card count always equals the
// filtered destination list. No page should re-derive these rules locally.
import { differenceInDays, parseISO } from 'date-fns'

// A "Sent" quotation past its validity window is effectively Expired (not awaiting signature anymore).
export function isExpiredQuote(q) {
  return !!q && q.status === 'Sent' && q.sent_date && differenceInDays(new Date(), parseISO(q.sent_date)) > (q.validity_days || 30)
}
export function effectiveStatus(q) { return isExpiredQuote(q) ? 'Expired' : ((q && q.status) || 'Draft') }
export function isActiveQuote(q) { const s = effectiveStatus(q); return s === 'Draft' || s === 'Sent' }

// Revision family = the quote_ref with the r<N> marker stripped (so q/444013-26/WT and q/444013r2-26/WT
// are one family even when revision_of was never populated). Highest revision = the head.
export function familyKey(q) { return String((q && q.quote_ref) || (q && q.id) || '').replace(/^([a-z]+\/\d+)r\d+(-.*)$/, '$1$2') }
export function revNum(q) { const m = String((q && q.quote_ref) || '').match(/r(\d+)/); return m ? parseInt(m[1], 10) : 0 }
const byRevDesc = (a, b) => (revNum(b) - revNum(a)) || (new Date(b.created_at) - new Date(a.created_at))

// Only the latest version of each family is a "head" (shown in the register / counted in KPIs).
export function quotationHeads(quotes) {
  const families = {}
  ;(quotes || []).forEach(q => { const k = familyKey(q); (families[k] = families[k] || []).push(q) })
  const headIds = new Set()
  Object.values(families).forEach(members => { const head = members.slice().sort(byRevDesc)[0]; if (head) headIds.add(head.id) })
  return (quotes || []).filter(q => headIds.has(q.id))
}

// KPI predicates (head quotes only) — identical to the Quotations page filters of the same name.
export const quotesToPrepare = (quotes) => quotationHeads(quotes).filter(q => effectiveStatus(q) === 'Draft')
export const quotesAwaitingSignature = (quotes) => quotationHeads(quotes).filter(q => effectiveStatus(q) === 'Sent')
